import React, { useState } from 'react';
import { Container, Typography, Box, Button } from '@mui/material';
import SuccessStoryForm from './SuccessStoryForm';
import SuccessStories from '../../../components/community/SuccessStories';
import { useApp } from '../../../context/AppContext';

const SuccessStoriesPage = () => {
  const [formOpen, setFormOpen] = useState(false);
  const { user } = useApp();

  // 합격 스토리 등록 후 목록 새로고침 등 추가 로직 필요시 여기에 작성
  const handleSuccess = () => {
    // 예: fetchStories() 호출 등
  };

  return (
    <Container maxWidth="lg">
      <Box sx={{ py: 4 }}>
        <Typography variant="h4" component="h1" gutterBottom>
          합격 스토리
        </Typography>
        <Typography variant="body1" color="text.secondary">
          다른 학습자들의 합격 사연을 공유해보세요.
        </Typography>
        <Box sx={{ mt: 3, display: 'flex', justifyContent: 'flex-end', alignItems: 'center', gap: 2 }}>
          <Button variant="contained" onClick={() => setFormOpen(true)} disabled={!user}>
            합격 스토리 작성
          </Button>
          {!user && (
            <Typography variant="caption" color="text.secondary">
              작성하려면 로그인하세요
            </Typography>
          )}
        </Box>
        <SuccessStories />
        <SuccessStoryForm
          open={formOpen}
          onClose={() => setFormOpen(false)}
          onSuccess={handleSuccess}
        />
      </Box>
    </Container>
  );
};

export default SuccessStoriesPage; 